module.exports = __webpack_public_path__ + "img/second-2-opened.7dd22e54.webp";